/*global VeloxViewController, VeloxWebView*/

var welcomeController = new VeloxViewController({
    directory : "views/welcome",
    name: "welcome",
    container: "welcome",
    route: "" //displayed by default
}) ;

function flattenCate(categories, cate, level){
    cate.level = level;
    categories.push(cate) ;
    if(cate.children){
        cate.children.forEach(function(c){
            flattenCate(categories, c, level+1) ;
        }) ;
    }
}

welcomeController.prepareDataOnEnter = function(dataSearch, callback){
    this.api.api.multiread({
        category: {search: {}, orderBy: "c_code", joinFetch: [
            { otherTable: "device", type: "2many", name: "devices", joins: [
                { 
                    otherTable: "velox_binary", 
                    thisField: "d_ref", otherField: "table_uid", name: "binary", joinSearch: {table_name:"device"}
                }
            ]}
        ]}
    }, function(err, reads){
        if(err){ return callback(err) ;}

        var cateById = {} ;
        reads.category.forEach(function(c){
            c.children = [] ;
            cateById[c.c_code] = c ;
        }) ;
        var cateHierarchy = reads.category.filter(function(c){ return !c.c_parent;}) ;
        var childrenCate = reads.category.filter(function(c){ return c.c_parent;}) ;
        while(childrenCate.length>0){
            var cate = childrenCate.pop() ;
            cateById[cate.c_parent].children.push(cate) ;
        }

        var sortedCategories = [] ;
        cateHierarchy.forEach(function(c){
            flattenCate(sortedCategories, c, 0) ;
        }) ;

        var country = VeloxWebView.i18n.getLang().substring(0,2) ;
        sortedCategories.forEach(function(cate){
            cate.devices = cate.devices.filter(function(device){
                if(!device.d_country || device.d_country.length === 0){
                    return true ;
                }
                return device.d_country.indexOf(country) !== -1 ;
            }) ;
        }) ;


        var data = {
            categories: sortedCategories,
            firstLevelCategories: sortedCategories.filter(function(c){ return c.level === 0 ;}),
            searchResults: null,
            search: dataSearch
        };

        welcomeController.doSearch(data, function(err){
            if(err){ return callback(err) ;}
            callback(null, data) ;
        }.bind(this)) ;

    }.bind(this)) ;
} ;

welcomeController.doSearch = function(data, callback){
    if(!data.search){ return callback() ;}
    var joinFetchPart = [{ 
        otherTable: "velox_binary", 
        thisField: "p_ref", otherField: "table_uid", name: "binary", joinSearch: {table_name:"part"}
    }] ;
    var joinFetchDevice = [{ 
        otherTable: "velox_binary", 
        thisField: "d_ref", otherField: "table_uid", name: "binary", joinSearch: {table_name:"device"}
    }] ;
    this.api.api.multiread({
        partName: {table: "part", search: {p_name: {ope: "ilike", value: "%"+data.search+"%"}}, joinFetch: joinFetchPart, orderBy: "p_name"},
        partDesc: {table: "part", search: {p_description: {ope: "ilike", value: "%"+data.search+"%"}}, joinFetch: joinFetchPart,orderBy: "p_name"},
        partRef:  {table: "part", search: {p_ref: data.search},joinFetch: joinFetchPart, orderBy: "p_name"},
        deviceName: {table: "device", search: {d_name: {ope: "ilike", value: "%"+data.search+"%"}}, joinFetch: joinFetchDevice, orderBy: "d_name"},
        deviceDesc: {table: "device", search: {d_description: {ope: "ilike", value: "%"+data.search+"%"}}, joinFetch: joinFetchDevice, orderBy: "d_name"},
        deviceRef:  {table: "device", search: {d_ref: data.search}, joinFetch: joinFetchDevice, orderBy: "d_name"},
    }, function(err, reads){
        if(err){ return callback(err) ;}

        var foundParts = {} ;
        var foundDevices = {} ;

        reads.partName.forEach(function(p){ foundParts[p.p_ref] = p ; });
        reads.partDesc.forEach(function(p){ foundParts[p.p_ref] = p ; });
        reads.partRef.forEach(function(p){ foundParts[p.p_ref] = p ; });
        reads.deviceName.forEach(function(d){ foundDevices[d.d_ref] = d ; });
        reads.deviceDesc.forEach(function(d){ foundDevices[d.d_ref] = d ; });
        reads.deviceRef.forEach(function(d){ foundDevices[d.d_ref] = d ; });

        var searchResults = {
            parts : [],
            devices : []
        } ;

        Object.keys(foundParts).forEach(function(k){
            searchResults.parts.push(foundParts[k]) ;
        }) ;
        Object.keys(foundDevices).forEach(function(k){
            searchResults.devices.push(foundDevices[k]) ;
        }) ;

        var country = VeloxWebView.i18n.getLang().substring(0,2) ;
        searchResults.devices = searchResults.devices.filter(function(device){
            if(!device.d_country || device.d_country.length === 0){
                return true ;
            }
            return device.d_country.indexOf(country) !== -1 ;
        }) ;

        data.searchResults = searchResults ;
        callback() ;
    }.bind(this));
} ;


welcomeController.onSearch = function(){
    this.view.updateData() ;
    this.updateRouteData("", this.data.search) ;
} ;


module.exports = welcomeController ;